import React from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { fmtDashboardLink } from '../../utils/formatters';

import { BucketIcon } from '.';

const useStyles = makeStyles((theme) => ({
  root: {
  },
}));

export default function DashboardIconButton(props) {
  const { name } = props;
  const classes = useStyles();

  const handleGoToDashboard = () => {
    window.open(fmtDashboardLink(name),"_blank");
  };

  if(name) {
    return (
      <IconButton className={classes.root} onClick={handleGoToDashboard}>
        <BucketIcon/>
      </IconButton>
    );
  } else {
    return(null);
  }
}

DashboardIconButton.propTypes = {
  name: PropTypes.string,
};

DashboardIconButton.defaultProps = {
};
